export default __webpack_public_path__ + "static/media/diy-hero.878f69a0.jpg";